(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('MyID', MyID);

    MyID.$inject = ['$resource', 'DateUtils'];

    function MyID ($resource, DateUtils) {
        var resourceUrl =  'api/my-ids/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertLocalDateFromServer(data.birthDate);
                        data.issuedDate = DateUtils.convertLocalDateFromServer(data.issuedDate);
                        data.expiryDate = DateUtils.convertLocalDateFromServer(data.expiryDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.issuedDate = DateUtils.convertLocalDateToServer(copy.issuedDate);
                    copy.expiryDate = DateUtils.convertLocalDateToServer(copy.expiryDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.birthDate = DateUtils.convertLocalDateToServer(copy.birthDate);
                    copy.issuedDate = DateUtils.convertLocalDateToServer(copy.issuedDate);
                    copy.expiryDate = DateUtils.convertLocalDateToServer(copy.expiryDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
